import _ from 'lodash';

// does lodash unset but also deletes parent objects if they are empty
export default function deepUnset(obj, propList) {
  if(typeof obj !== 'object') {
    return console.log('first argument must be object');
  }

  if(typeof propList === 'string') propList = propList.split('.');
  else if(!Array.isArray(propList)) return console.log('second argument must be either string or array');
  else propList = propList.reduce((prev, curr) => prev.concat(curr.split('.')), []);

  // remove origin
  _.unset(obj, propList);
  propList.pop();
  while(propList.length && _.chain(obj).get(propList).isEmpty().value()) {
    _.unset(obj, propList);
    propList.pop();
  }
}



// WEBPACK FOOTER //
// ./shared/lib/deepUnset.js